import apiClient from "@/api/client";

export default {
  fetchObservations() {
    return apiClient.get("/observations");
  },
};
